class PMStickyMobileCart extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.priceNode = this.querySelector('[data-pm-sticky-price]');
    this.button = this.querySelector('[data-pm-sticky-submit]');
    this.mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.mainPrice = document.getElementById(`price-${this.sectionId}`);

    this.onSubmit = this.handleSubmit.bind(this);
    this.onVariantChange = this.handleVariantChange.bind(this);
    this.onLpoPrice = this.handleLpoPrice.bind(this);
    this.onMainButtonMutation = this.syncButtonState.bind(this);
    this.onPriceMutation = () => this.syncPriceFromMain();

    this.button?.addEventListener('click', this.onSubmit);
    document.addEventListener('lpo:price', this.onLpoPrice);
    document.body.classList.add('pm-sticky-cart-visible');

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    if (this.mainSubmit) {
      this.buttonObserver = new MutationObserver(this.onMainButtonMutation);
      this.buttonObserver.observe(this.mainSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
      });
    }

    if (this.mainPrice) {
      this.priceObserver = new MutationObserver(this.onPriceMutation);
      this.priceObserver.observe(this.mainPrice, { childList: true, subtree: true, characterData: true });
    }

    this.syncButtonState();
    this.syncPriceFromMain();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onSubmit);
    document.removeEventListener('lpo:price', this.onLpoPrice);
    this.unsubscribeVariantChange?.();
    this.buttonObserver?.disconnect();
    this.priceObserver?.disconnect();
    document.body.classList.remove('pm-sticky-cart-visible');
  }

  handleSubmit() {
    if (!this.mainSubmit || this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true') return;

    this.mainSubmit.click();
  }

  handleVariantChange(event) {
    if (event?.data?.sectionId !== this.sectionId) return;

    this.syncButtonState();
    window.requestAnimationFrame(() => this.syncPriceFromMain(event.data.html));
  }

  handleLpoPrice(event) {
    const price = event?.detail?.price;

    if (typeof price === 'string' && price.trim()) {
      this.setPrice(price);
      return;
    }

    if (typeof price === 'number' && Number.isFinite(price)) {
      this.setPrice(this.formatNumberPrice(price));
    }
  }

  formatNumberPrice(price) {
    const currentPrice = this.priceNode?.textContent?.trim() || '';
    const currencyPrefix = currentPrice.match(/^[^\d-]+/)?.[0] || '\u20ac';
    const normalizedPrice = price > 999 ? price / 100 : price;

    return `${currencyPrefix}${normalizedPrice.toFixed(2)}`;
  }

  syncPriceFromMain(sourceDocument = document) {
    const price =
      sourceDocument
        ?.querySelector(`#price-${this.sectionId} .price-item--sale`)
        ?.textContent?.trim() ||
      sourceDocument
        ?.querySelector(`#price-${this.sectionId} .price-item--regular`)
        ?.textContent?.trim() ||
      this.mainPrice?.querySelector('.price-item--sale')?.textContent?.trim() ||
      this.mainPrice?.querySelector('.price-item--regular')?.textContent?.trim();

    if (price) this.setPrice(price);
  }

  setPrice(price) {
    if (!this.priceNode) return;

    this.priceNode.textContent = price;
  }

  syncButtonState() {
    if (!this.button || !this.mainSubmit) return;

    const disabled = this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true';
    this.button.toggleAttribute('disabled', disabled);
    this.button.setAttribute('aria-disabled', String(disabled));

    const mainText = this.mainSubmit.querySelector('span')?.textContent?.trim();
    if (mainText) this.button.textContent = mainText;
  }
}

if (!customElements.get('pm-sticky-mobile-cart')) {
  customElements.define('pm-sticky-mobile-cart', PMStickyMobileCart);
}

